import React, { useContext } from "react";
import { useQuery } from "@apollo/client/react";
import gql from "graphql-tag";
import { GlobalContext } from "../contexts/GlobalContext";
import { AuthContext } from "../contexts/AuthContext";
import TablePage from "./TablePage";
import DeadlinesPage from "./DeadlinesPage";
import CurrentCupFixturesPage from "./CurrentCupFixturesPage";
import PageHeader from "../components/PageHeader";
import H2HFixtures from "../components/H2HFixtures";
import LiveMatches from "../components/LiveMatches";
import { DEFAULT_HOME_WIDGETS } from "../config/homeWidgets";
import { faFutbol } from "@fortawesome/free-solid-svg-icons";

const GET_HOME_WIDGETS = gql`
  query {
    getHomeWidgets
  }
`;

function Home() {
  const { globalSeasonId, globalGameweek, globalLeagueMode } =
    useContext(GlobalContext);
  const { user } = useContext(AuthContext);
  const { data } = useQuery(GET_HOME_WIDGETS, { skip: !user });

  const h2hGameweek = Math.max(1, globalGameweek);

  const activeWidgets =
    data && data.getHomeWidgets && data.getHomeWidgets.length > 0
      ? data.getHomeWidgets
      : DEFAULT_HOME_WIDGETS;

  const renderWidget = (key) => {
    switch (key) {
      case "liveMatches":
        return (
          <div className="home-widget" key={key}>
            <PageHeader
              pageTitle="Live Matches"
              gameweek={globalGameweek}
              icon={faFutbol}
            />
            <LiveMatches />
          </div>
        );
      case "table":
        return (
          <div className="home-widget" key={key}>
            <TablePage />
          </div>
        );
      case "deadlines":
        return (
          <div className="home-widget" key={key}>
            <DeadlinesPage />
          </div>
        );
      case "fixtures":
        return (
          <div className="home-widget" key={key}>
            {globalLeagueMode === "HeadToHead" ? (
              <div>
                <PageHeader
                  pageTitle="H2H Fixtures"
                  gameweek={h2hGameweek}
                  icon={faFutbol}
                />
                <H2HFixtures
                  seasonId={globalSeasonId}
                  gameweek={h2hGameweek}
                />
              </div>
            ) : (
              <CurrentCupFixturesPage />
            )}
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>{activeWidgets.map((key) => renderWidget(key))}</React.Fragment>
  );
}

export default Home;
